/* 🤖 this file was generated by svg-to-ts */
export const svgBackCurvedArrow: {
    name: "back-curved-arrow";
    data: string;
} = {
    name: "back-curved-arrow",
    data: `<svg xmlns="http://www.w3.org/2000/svg"><symbol id="ng__back-curved-arrow" viewBox="0 0 20 20"><path d="M10.5 11.29H.56a.554.554 0 01-.56-.56c0-.314.246-.56.56-.56h9.94a3.24 3.24 0 003.224-3.224A3.24 3.24 0 0010.5 3.722H5.037a.554.554 0 01-.56-.56c0-.313.247-.56.56-.56H10.5a4.323 4.323 0 014.32 4.321c0 2.44-1.924 4.366-4.32 4.366z"/><path d="M6.65 6.409a.551.551 0 01-.426-.202L4.03 3.61a.515.515 0 010-.694L6.224.207a.565.565 0 01.783-.09.565.565 0 01.09.784l-1.903 2.35 1.903 2.262c.202.224.157.582-.067.784a.908.908 0 01-.38.112z"/></symbol></svg>`,
};
